import React, { useState } from "react";
import DrawerFilter from "../../../components/listing/DrawerFilter";
import InputNumberNoScroll from "../../../components/inputs/inputNumberNoScroll";

export default function FiltroTransaccionesBancard({
  initialFilters = {},
  onSubmit = () => {},
  onClose = () => {},
}) {
  // ===========================
  // 1. ESTADOS (Ordenados según la imagen Legacy)
  // ===========================
  
  // Nro. Boleta (En la entidad suele ser numeroComprobante)
  const [numeroComprobante, setNumeroComprobante] = useState(initialFilters.numeroComprobante || "");
  
  // Nro. Remito (Numeric)
  const [numeroRemito, setNumeroRemito] = useState(initialFilters.numeroRemito || "");
  
  // Nro. Tarjeta
  const [numeroTarjeta, setNumeroTarjeta] = useState(initialFilters.numeroTarjeta || "");
  
  // Nro. Tarjeta Supervisor
  const [numeroTarjetaSuper, setNumeroTarjetaSuper] = useState(initialFilters.numeroTarjetaSuper || "");
  
  // Cod. Comercio
  const [codigoComercio, setCodigoComercio] = useState(initialFilters.codigoComercio || "");
  
  // Nro. Pin Chofer
  const [codigoPinChofer, setCodigoPinChofer] = useState(initialFilters.codigoPinChofer || "");
  
  // Nro. Pin EE.SS.
  const [codigoPinEess, setCodigoPinEess] = useState(initialFilters.codigoPinEess || "");
  
  // Cod. Producto 1
  const [codigoProductofixme, setCodigoProductofixme] = useState(initialFilters.codigoProductofixme || "");
  
  // Cant. Prod. 1
  const [qnProductofixme, setQnProductofixme] = useState(initialFilters.qnProductofixme || "");
  
  // Cod. Producto 2
  const [codigoProductofixme1, setCodigoProductofixme1] = useState(initialFilters.codigoProductofixme1 || "");
  
  // Cant. Producto 2
  const [qnProductofixme1, setQnProductofixme1] = useState(initialFilters.qnProductofixme1 || "");
  
  // Fecha Transaccion (Date)
  const [dataTransaccion, setDataTransaccion] = useState(initialFilters.dataTransaccion || "");
  
  // Tipo Transaccion (Enum)
  const [codigoTipoTransaccion, setCodigoTipoTransaccion] = useState(initialFilters.codigoTipoTransaccion || "");
  
  // Mensaje de Estado (Enum)
  const [descricaoMsgStatus, setDescricaoMsgStatus] = useState(initialFilters.descricaoMsgStatus || "");

  const [isLoading, setIsLoading] = useState(false);

// ===========================
  // 2. HANDLER APLICAR
  // ===========================
 const handleApply = async () => {
    setIsLoading(true);

    const filtrosAplicados = {
      numeroComprobante: numeroComprobante ? parseInt(numeroComprobante) : null,
      numeroRemito: numeroRemito ? numeroRemito.toString().trim() : "",
      numeroTarjeta: numeroTarjeta.trim(),
      numeroTarjetaSuper: numeroTarjetaSuper.trim(),
      codigoComercio: codigoComercio.trim(),
      codigoPinChofer: codigoPinChofer.trim(),
      codigoPinEess: codigoPinEess.trim(),
      codigoProductofixme: codigoProductofixme.trim(),
      qnProductofixme: qnProductofixme.trim(),
      codigoProductofixme1: codigoProductofixme1.trim(),
      qnProductofixme1: qnProductofixme1.trim(),

      dataTransaccion: dataTransaccion || null,

      codigoTipoTransaccion: codigoTipoTransaccion || null,
      descricaoMsgStatus: descricaoMsgStatus || null
    };

    await new Promise(r => setTimeout(r, 200));
    onSubmit(filtrosAplicados);
    setIsLoading(false);
    onClose();
  };

  // ===========================
  // 3. RENDER
  // ===========================
  return (
    <DrawerFilter
      title="Filtros Transacciones"
      onClose={onClose}
      onApply={handleApply}
      isLoading={isLoading}
    >
      {/* 1. Nro. Boleta */}
      <div>
        <label className="form-label-fil">Nro. Boleta:</label>
        <input
          type="text"
          className="input mt-1 w-full"
          value={numeroComprobante}
          onChange={(e) => setNumeroComprobante(e.target.value)}
        />
      </div>

      {/* 2. Nro. Remito (Con bloqueo de scroll y flechas) */}
      <div>
        <label className="form-label-fil">Nro. Remito:</label>
        <InputNumberNoScroll
          className="input mt-1 w-full"
          value={numeroRemito}
          onChange={(e) => setNumeroRemito(e.target.value)}
          placeholder="Ingrese el remito" // Opcional
        />
      </div>

      {/* 3. Nro. Tarjeta */}
      <div>
        <label className="form-label-fil">Nro. Tarjeta:</label>
        <input
          type="text"
          className="input mt-1 w-full"
          value={numeroTarjeta}
          onChange={(e) => setNumeroTarjeta(e.target.value)}
        />
      </div>

      {/* 4. Nro. Tarjeta Supervisor */}
      <div>
        <label className="form-label-fil">Nro. Tarjeta Supervisor:</label>
        <input
          type="text"
          className="input mt-1 w-full"
          value={numeroTarjetaSuper}
          onChange={(e) => setNumeroTarjetaSuper(e.target.value)}
        />
      </div>

      {/* 5. Cod. Comercio */}
      <div>
        <label className="form-label-fil">Cód. Comercio:</label>
        <input
          type="text"
          className="input mt-1 w-full"
          value={codigoComercio}
          onChange={(e) => setCodigoComercio(e.target.value)}
        />
      </div>

      {/* 6. Nro. Pin Chofer */}
      <div>
        <label className="form-label-fil">Nro. Pin Chofer:</label>
        <input
          type="text"
          className="input mt-1 w-full"
          value={codigoPinChofer}
          onChange={(e) => setCodigoPinChofer(e.target.value)}
        />
      </div>

      {/* 7. Nro. Pin EE.SS. */}
      <div>
        <label className="form-label-fil">Nro. Pin EE.SS.:</label>
        <input
          type="text"
          className="input mt-1 w-full"
          value={codigoPinEess}
          onChange={(e) => setCodigoPinEess(e.target.value)}
        />
      </div>

      {/* 8. Cod. Producto 1 */}
      <div>
        <label className="form-label-fil">Cód. Producto 1:</label>
        <input
          type="text"
          className="input mt-1 w-full"
          value={codigoProductofixme}
          onChange={(e) => setCodigoProductofixme(e.target.value)}
        />
      </div>

      {/* 9. Cant. Prod. 1 */}
      <div>
        <label className="form-label-fil">Cant. Prod. 1:</label>
        <input
          type="text"
          className="input mt-1 w-full"
          value={qnProductofixme}
          onChange={(e) => setQnProductofixme(e.target.value)}
        />
      </div>

      {/* 10. Cod. Producto 2 */}
      <div>
        <label className="form-label-fil">Cód. Producto 2:</label>
        <input
          type="text"
          className="input mt-1 w-full"
          value={codigoProductofixme1}
          onChange={(e) => setCodigoProductofixme1(e.target.value)}
        />
      </div>

      {/* 11. Cant. Producto 2 */}
      <div>
        <label className="form-label-fil">Cant. Producto 2:</label>
        <input
          type="text"
          className="input mt-1 w-full"
          value={qnProductofixme1}
          onChange={(e) => setQnProductofixme1(e.target.value)}
        />
      </div>

    {/* 12. Fecha Transaccion */}
      <div>
        <label className="form-label-fil">Fecha Transaccion (Texto):</label>
        <input
          type="date"
          className="input mt-1 w-full"
          value={dataTransaccion}
          onChange={(e) => setDataTransaccion(e.target.value)}
        />
      </div>

      {/* 13. Tipo Transaccion (Enum) */}
      <div>
        <label className="form-label-fil">Tipo Transaccion:</label>
        <select
          className="input mt-1 w-full"
          value={codigoTipoTransaccion}
          onChange={(e) => setCodigoTipoTransaccion(e.target.value)}
        >
          <option value="">-- Seleccione --</option>
          {/* Enum: TransaccionBancardEnum */}
          <option value="CONSULTA_SALDO">CONSULTA_SALDO</option>
          <option value="VENTA_PRODUCTO">VENTA_PRODUCTO</option>
          <option value="ANULACION">ANULACION</option>
          <option value="VENTA_MANUAL">VENTA_MANUAL</option>
          <option value="REVERSA">REVERSA</option>
        </select>
      </div>

      {/* 14. Mensaje de Estado (Enum) */}
      <div>
        <label className="form-label-fil">Mensaje de Estado:</label>
        <select
          className="input mt-1 w-full"
          value={descricaoMsgStatus}
          onChange={(e) => setDescricaoMsgStatus(e.target.value)}
        >
          <option value="">-- Seleccione --</option>
          {/* Enum: StatusTransaccionBancardEnum */}
          <option value="success">Success</option>
          <option value="error">Error</option>
          <option value="warning">Warning</option>
          <option value="info">Info</option>
        </select>
      </div>

    </DrawerFilter>
  );
}